import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import modalConsts from 'Consts/ModalNames';
import { openModal } from 'Helpers/ModalHelper';
import { noop } from 'Helpers/PropTypes';
import fr from 'facet-rest';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { Typography } from '@material-ui/core';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { RolloverRecommendationQuestionnaireTimeline } from 'Overrides/BulkRolloverRecommendationQuestionnaireTable';
import AgendaDetail from './Agenda';
import EmailViewer from './Email';
import FileViewer from './File';

const styles = theme => ({
  root: {
    padding: theme.spacing(3),
    flex: 1,
  },
  noteDisplay: {
    cursor: 'pointer',
  },
  rolloverRecommendationContainer: {
    width: '100%',
  },
});

const DetailContent = ({
  eventKey,
  category,
  id,
  household,
  description,
  className,
  data,
  relatedActionItemsLink,
  name,
  relatedResource: relatedResourceURL,
  classes,
}) => {
  const [error, setError] = React.useState(null);
  const [relatedResource, setRelatedResource] = React.useState(null);

  React.useEffect(() => {
    async function loadRelatedResource() {
      const [resource] = await fr.http.get(relatedResourceURL);
      setRelatedResource(resource);
    }

    if (relatedResourceURL) {
      loadRelatedResource().catch(e => {
        displayErrorMessage(e, e.errors);
        setError(e.errors);
      });
    }
  }, [relatedResourceURL]);

  if (error) {
    return (
      <div>
        <Typography color="error" variant="h1">
          {'Failed to load.'}
        </Typography>
      </div>
    );
  }
  switch (eventKey) {
    case 'RolloverRecommendationQuestionnaire': {
      return (
        relatedResource && (
        <div className={classes.rolloverRecommendationContainer}>
          <MetaFormInline
            resource={relatedResource.overrideMeta(RolloverRecommendationQuestionnaireTimeline)}
            onSubmit={noop}
            readonly
          />
        </div>
        )
      );
    }
    case 'email':
    case 'otherEmail':
      return <EmailViewer id={id} />;
    case 'uploadFile':
      return <FileViewer fileId={id} householdResource={household} />;
    case 'uploadFileIdentityVerification':
      return <p>Member completed an identity verification</p>;
    case 'note':
      return (
        <div
          className={className}
          role="presentation"
          onClick={() => openModal(modalConsts.advisorNote, [{ noteId: id }])}
        >
          <RichTextDisplay content={description} />
        </div>
      );
    case 'client-call':
    case 'advisor-call':
    case 'other-call':
      return <div className={className}>{name}</div>;
    default:
      break;
  }

  // for handling more specific types of events
  switch (category) {
    case 'agenda':
      return (
        <AgendaDetail
          householdResource={household}
          eventData={data}
          eventId={id}
          relatedActionItemsLink={relatedActionItemsLink}
        />
      );
    default:
      return null;
  }
};

const Detail = ({
  classes, className, event, householdResource,
}) => {
  return (
    <div
      className={classNames({
        [classes.root]: true,
        [className]: true,
        [classes.noteDisplay]: event.eventKey === 'note',
      })}
    >
      <DetailContent
        {...event}
        household={householdResource}
        classes={classes}
        className={classNames({
          [classes.noteDisplay]: event.eventKey === 'note',
        })}
      />
    </div>
  );
};

Detail.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  event: PropTypes.object.isRequired,
  householdResource: PropTypes.object.isRequired,
};

Detail.defaultProps = {
  className: '',
};

export default withStyles(styles)(Detail);
